import { render, staticRenderFns } from "./subscriptionplan.vue?vue&type=template&id=2c0bd34a&"
import script from "./subscriptionplan.vue?vue&type=script&lang=js&"
export * from "./subscriptionplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports